<ion-item>
  <ion-label [innerHTML]="audit.when" class="ion-text-wrap"></ion-label>
  <ion-text [innerHTML]="audit.audit"></ion-text>
</ion-item>